"use strict";

var darkMode = document.querySelector(".mode");
var LocalMode =  localStorage.getItem("themeMode");

if(LocalMode == "dark"){
    document.body.classList.add("darkMode");
    darkMode.classList.add("mode__moon");
}

darkMode.addEventListener(("click"),(e)=>{
    darkMode.classList.toggle("mode__moon");
    document.body.classList.toggle("darkMode");
    if(document.body.classList.contains("darkMode")){
        localStorage.setItem("themeMode", "dark");
    }else{
        localStorage.setItem("themeMode", "light");
    } 
})